/**
 * @generated SignedSource<<e6f661f31336cf2f21a33f8479398695>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeletePointPoolInput = {
  clientMutationId?: string | null | undefined;
  ids: ReadonlyArray<string>;
};
export type PointPoolsTable_DeletePointPoolMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeletePointPoolInput;
};
export type PointPoolsTable_DeletePointPoolMutation$data = {
  readonly Admin: {
    readonly Points: {
      readonly deletePointPool: {
        readonly deletedIds: ReadonlyArray<string>;
      } | null | undefined;
    };
  };
};
export type PointPoolsTable_DeletePointPoolMutation = {
  response: PointPoolsTable_DeletePointPoolMutation$data;
  variables: PointPoolsTable_DeletePointPoolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PointPoolsTable_DeletePointPoolMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PointsAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Points",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeletePointPoolPayload",
                "kind": "LinkedField",
                "name": "deletePointPool",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PointPoolsTable_DeletePointPoolMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PointsAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Points",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeletePointPoolPayload",
                "kind": "LinkedField",
                "name": "deletePointPool",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedIds",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ee4d64ae82085eb3bb88a2729a1c796f",
    "id": null,
    "metadata": {},
    "name": "PointPoolsTable_DeletePointPoolMutation",
    "operationKind": "mutation",
    "text": "mutation PointPoolsTable_DeletePointPoolMutation(\n  $input: DeletePointPoolInput!\n) {\n  Admin {\n    Points {\n      deletePointPool(input: $input) {\n        deletedIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7a1e8382d5c46b493df59061d41c3647";

export default node;
